module.exports = __webpack_public_path__ + "static/media/congrats-ribbonTBN.55e1316e.png";